import moment from 'moment';
import { Injectable } from '@angular/core';
import { get, has } from 'lodash';

export const APPOINTMENT_START = 'start';
export const APPOINTMENT_DURATION = 'minutesDuration';

@Injectable()
export class AppointmentService {

  public checkStartExceeds(appointment: any) {
    if (has(appointment, APPOINTMENT_START) && has(appointment, APPOINTMENT_DURATION)) {
      const endTime = moment(new Date(appointment[APPOINTMENT_START])).add(parseInt(get(appointment, APPOINTMENT_DURATION)), 'minutes');

      return endTime.isBefore(moment());
    }

    return false;
  }
}
